import React from 'react';
import {
  Box, Button, Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import InputWrap from '../atoms/InputWrap';
import TextFieldStatus from '../atoms/TextFieldStatus';
import MaskedTextField from './MaskedTextField';

/**
 * Segunda etapa do formulario de trocar contador (TXM-626): so o CNPJ.
 *
 * O CNPJ e opcional aqui de proposito. Ele era obrigatorio na etapa unica e
 * derrubava a campanha: quem nao tinha o numero a mao desistia antes de enviar,
 * e o lead se perdia. Agora o lead ja entrou no HubSpot na etapa 1, e esta
 * etapa so complementa. Por isso o ENVIAR tambem funciona com o campo vazio,
 * fazendo o papel de "pular" (o Figma nao tem botao de pular).
 *
 * Fica num componente proprio porque o hero desktop (SwitchAccountantFormDesk)
 * e o mobile (FormMobile) mostram exatamente a mesma etapa.
 */
export default function SwitchAccountantCnpjStep({
  cnpj,
  error,
  errorRoot,
  isLoading,
  disabled,
  buttonClassName,
  onChange,
  onSubmit,
}) {
  return (
    <>
      <Typography style={{ paddingBottom: '24px', color: '#383743' }}>
        Para agilizarmos o seu atendimento, digite seu CNPJ no campo abaixo.
      </Typography>
      <Box style={{ paddingBottom: '32px' }}>
        {/* column: campo unico ocupa a largura do card, como no Figma. Sem isso
            o InputWrap divide em duas colunas e o CNPJ fica pela metade. */}
        <InputWrap column>
          <MaskedTextField
            onChange={(e) => onChange(e.target.value)}
            mask="99.999.999/9999-99"
            textFieldProps={{
              label: 'CNPJ',
              name: 'cnpj',
              type: 'text',
              value: cnpj,
              floating: true,
              error: Boolean(error),
              helperText: error,
            }}
            placeholder="00.000.000/0000-00"
            InputLabelProps={{
              shrink: true,
              error: false,
              focused: false,
            }}
            InputProps={{
              disabled: isLoading,
              endAdornment: (
                <TextFieldStatus
                  error={Boolean(error)}
                  value={cnpj && !error}
                />
              ),
            }}
          />
        </InputWrap>
      </Box>

      {errorRoot && <Typography component="span" style={{ color: '#D12E26' }}>{errorRoot}</Typography>}

      <Box style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          className={buttonClassName}
          style={{ maxWidth: '238px', height: '55px' }}
          disabled={disabled}
          name="enviar-cnpj"
          type="button"
          onClick={onSubmit}
        >
          ENVIAR
        </Button>
      </Box>
    </>
  );
}

SwitchAccountantCnpjStep.defaultProps = {
  cnpj: '',
  error: undefined,
  errorRoot: undefined,
  isLoading: false,
  disabled: false,
  buttonClassName: undefined,
};

SwitchAccountantCnpjStep.propTypes = {
  cnpj: PropTypes.string,
  error: PropTypes.string,
  errorRoot: PropTypes.string,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  buttonClassName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
